import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { RoutingHistoryService } from '../../../services/routing-history.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {
  @Input() img: string;
  @Input() showLabel: boolean = true;
  queryParams: { [key: string]: any; };
  url: any;
  text: Observable<string>;
  disabled: boolean = false;

  constructor(private historyService: RoutingHistoryService) { }

  ngOnInit() {
    this.text = this.historyService.backToText;
    this.url = this.historyService.returnUrl;
    this.queryParams = this.historyService.returnQueryParams;
  }

  goBack() {
    if (!this.disabled) {
      this.historyService.pop();
    }
    // prevent double click from removing more history than it should
    this.disabled = true;
  }
}
